import { combine, persist } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

export const saveKey = 'trade-setting';

// store
export const useTradeSettingStore = createWithEqualityFn(
  persist(
    combine(
      {
        slippage: 3,
        deadline: 30,
        isAutoSlippage: true,
        autoSlippageDisplay: 0, // computed auto slippage % for UI display
      },
      set => {
        return {
          setSlippage(slippage: number) {
            set({ slippage });
          },
          setDeadline(deadline: number) {
            set({ deadline });
          },
          setIsAutoSlippage(isAutoSlippage: boolean) {
            set({ isAutoSlippage });
          },
          setAutoSlippageDisplay(autoSlippageDisplay: number) {
            set({ autoSlippageDisplay });
          },
        };
      }
    ),
    { name: saveKey }
  ),
  shallow
);

export type TradeType = 'buy' | 'sell';
export type OptionSide = 'yes' | 'no';

export type TradeParams = {
  type: TradeType;
  marketAddress: string;
  amount?: bigint;
  optionAddress?: string;
  optionSide?: OptionSide; // For multi-option markets: which side (yes/no) to buy
};

// store
export const useTradeParamsStore = createWithEqualityFn(
  combine(
    {
      type: 'buy' as TradeType,
      marketAddress: '',
      uid: undefined,
      optionAddress: undefined,
      optionSide: undefined,
      amount: undefined,
    } as TradeParams,
    set => ({
      setType: (type?: TradeType) => set({ type }),
      setMarketAddress: (marketAddress: string) => set({ marketAddress }),
      setOptionAddress: (optionAddress: string) => set({ optionAddress }),
      setOptionSide: (optionSide?: OptionSide) => set({ optionSide }),
      setAmount: (amount?: bigint) => set({ amount }),
      setTradeParams: (tradeParams: TradeParams & { type?: TradeType }) => set(tradeParams),
      margeTradeParams: (tradeParams: Partial<TradeParams>) => set(state => ({ ...state, ...tradeParams })),
    })
  ),
  shallow
);
